import { useProductItemThemeSettings } from '@providers/ThemeProvider/Provider/ProductItemThemeSettings';

import type { ProductImageProps } from '@/features/filter-product-list/product-list/product-item/ProductImage';

import type { ProductCTAPropsMapSettings } from './connectCTAButton';
import { useConnectCTAButton } from './connectCTAButton';
import type { ProductLabelPropsMapSettings } from './connectProductLabel';
import { useConnectProductLabel } from './connectProductLabel';
import type { ProductRatingPropsMapSettings } from './connectProductRating';
import { useConnectProductRating } from './connectProductRating';
import type { ProductSwatchesPropsMapSettings } from './connectProductSwatches';

export type ProductImgPropsMapSettings = Pick<
  ProductImageProps,
  | 'aspectRatio'
  | 'isAutoRatio'
  | 'manualAspectRatio'
  | 'hoverEffect'
  | 'grid'
  | 'cropPosition'
  | 'loadedImageSizeStrategy'
> & {
  elements: {
    saleLabel?: ProductLabelPropsMapSettings;
    soldOutLabel?: ProductLabelPropsMapSettings;
    customLabelByTag?: ProductLabelPropsMapSettings;
    swatches?: ProductSwatchesPropsMapSettings;
    cta?: ProductCTAPropsMapSettings;
    rating?: ProductRatingPropsMapSettings;
  };
};

export const useConnectProductImg = () =>
  // productSwatch: ProductSwatchesProps

  {
    const settings = useProductItemThemeSettings();
    const { props: productCTAProps } = useConnectCTAButton(settings, 'img');
    const { props: productRatingProps } = useConnectProductRating(settings, 'img');
    const { props: productSaleLabelProps } = useConnectProductLabel(settings, 'productSaleLabel');
    const { props: productSoldOutLabelProps } = useConnectProductLabel(
      settings,
      'productSoldOutLabel'
    );
    const { props: productCustomLabelByTagProps } = useConnectProductLabel(
      settings,
      'productCustomLabelByTag'
    );
    const productImgSettings = settings.productImg;

    const props = {
      grid: productImgSettings.grid,
      aspectRatio: productImgSettings.aspectRatioType,
      isAutoRatio: productImgSettings.aspectRatioType === 'auto',
      manualAspectRatio: productImgSettings.manualAspectRatio,
      cropPosition: productImgSettings.cropPosition,
      hoverEffect: productImgSettings.hoverEffect,
      elements: {
        cta: productCTAProps,
        rating: productRatingProps,
        saleLabel: productSaleLabelProps,
        soldOutLabel: productSoldOutLabelProps,
        customLabelByTag: productCustomLabelByTagProps,
      },
      loadedImageSizeStrategy: productImgSettings.loadedImageSizeStrategy,
    };

    return {
      props,
    };
  };
